<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
    <basic-table
      v-if="dhcpLease"
      :items="dhcpLease"
      :fields="dhcpLeaseFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      :editImageProp="expireImage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      expireImage: require('@/assets/img/expire2.png'),
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      poolsData: new Map(),
      dhcpLeaseFields: [
        {key: 'lease_id', label: 'ID', sortable: true},
        {key: 'ip', label: this.$i18n.t('IP'), sortable: true},
        {key: 'mac', label: this.$i18n.t('MAC'), sortable: true},
        {key: 'server_id', label: this.$i18n.t('Server id'), sortable: true},
        {key: 'client_id', label: this.$i18n.t('Client id'), sortable: true},
        {key: 'expiredHR', label: this.$i18n.t('Expired'), sortable: true},
        {key: 'updatedHR', label: this.$i18n.t('Updated'), sortable: true},
        {key: 'flags_string', label: this.$i18n.t('Flags'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    async editItem (item) {
      let response = this.$store.dispatch('Inventory/EXPIRE_DHCP_LEASE', item.lease_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Lease has been expiring'))
          let index = this.dhcpLease.findIndex(element => element.lease_id === item.lease_id)
          this.dhcpLease[index]._rowVariant = 'danger'
        }
      })
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to drop that lease?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Inventory/', item.lease_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_DHCP_LEASE')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    dhcpLease () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_LEASE']))
      let nowTime = Math.round((new Date()).getTime() / 1000)
      copy.forEach(function (item) {
        if (item.expired <= nowTime) {
          item._rowVariant = 'danger'
        }
        item.expiredHR = moment(Number(item.expired) * 1000).format('MM-DD-YYYY HH:mm')
        item.updatedHR = moment(Number(item.updated) * 1000).format('MM-DD-YYYY HH:mm')
        switch (item.flags) {
          case 0:
            item.flags_string = 'static'
            break
          case 1:
            item.flags_string = 'dynamic_active'
            break
          case 2:
            item.flags_string = 'dynamic_inactive'
            break
          case 4:
            item.flags_string = 'modified'
            break
          default:
            break
        }
      })
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Inventory/GET_DHCP_LEASE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/dhcpLease/main.vue